import React, { useEffect, useState } from "react";
import {
  Layout,
  Space,
  PageHeader,
   Table,
    Popconfirm,
    Button,
    Checkbox,
    Modal,
    Input,
    message
} from "antd";
import R2Footer from "../../../components/Footer";

import Delete from "../../../assets/images/delete_icon.svg";
import { PlusCircleFilled } from "@ant-design/icons";
import "./styles.scss";
import SettingsService from "../../../services/SettingsService";
import Spinner from "../../../components/Layout/Spinner";


const { Content } = Layout;

const CateringSettings = (props) => {
  const [showAdd, setShowAdd] = useState(false);
  const [loading, setIsLoading] = useState(false);
  const [eventList, setEventList] = useState([]);
  const [name, setName] = useState("");


  const getEventList = () => {
    SettingsService.getCateringEvents().then((resp)=>{
        setEventList(resp);
    });
  };
  const saveEvent = () => {
    if(name) {
      const eventTypes = eventList.map(item => item.event_type_name);
      
       eventTypes.push(name);
       setIsLoading(true)
      SettingsService.saveCateringEvent(
        eventTypes
      ).then((res)=>{
        if(res){
          getEventList();
          setName("");
          setShowAdd(false);
          setIsLoading(false)
          message.success("Saved successfully");
        }
      });
    } else {
      message.warning("Enter event name");
    } 
  };
  const deleteStation = (deleteEvent) =>{
    const eventTypes = eventList.filter(item => item.event_type_name != deleteEvent).map( item => item.event_type_name);
      
       
      SettingsService.saveCateringEvent(
        eventTypes
      ).then((res)=>{
        if(res){
          getEventList();
          setName("");
          setShowAdd(false);
          message.success("Saved successfully");
        }
      });
       
  }

  useEffect(()=>{
    getEventList();
  }, []);

  const columns = [
    {
        title: 'Event Name',
        dataIndex: 'event_type_name',
        key: 'event_type_name',
        width: '40%' 
    },
    
    {
        title: 'Action',
        width: '15%', 
        render: (_, record) => {
            return <div
                style={{
                    display: "flex", width: '150px'}}>
                    <>
                        <Popconfirm title="Sure to delete?" onConfirm={(e) => {
                            e.stopPropagation()
                            deleteStation(record.event_type_name)
                        }
                        }>
                        <img src={Delete} alt="" className="update_action" />
                        </Popconfirm>
                    </>
            </div>
        }
    }
];
  return (
    <Layout className="u-page-layout catering-events-settings">
      <Content className="page-padding">
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader className="page-header" title="Catering Events" style={{ background: "#f0f2f5" }} />
          <div style={{ textAlign: 'end'}}>
            <Button type="text" icon={<PlusCircleFilled/>} danger className="addparties-btn" onClick={()=> setShowAdd(true)}>
            Add Event
            </Button>
          </div>
          <div className="table_section">
            <Table columns={columns} bordered dataSource={eventList} className="customise-table" />
          </div>
          <Modal title="Add Event" visible={showAdd} footer={null} onCancel={()=>setShowAdd(false)}>
            <div className="station_txt"><Input placeholder='Enter Event name' value={name} onChange={(e)=> { setName(e.target.value) }} /></div>
            
            <div className='save_course_setting'>
                <Button type='primary' onClick={()=> saveEvent()}>Save</Button>
            </div>
        </Modal>
        </Space>
        {loading && <Spinner/>}
      </Content>
      <R2Footer />
    </Layout>
  );
};


export default CateringSettings;
